/**
 * Merge pickup. Caught by flask mouth only. bottomCenterPosition (0–1), width (fraction).
 */
import * as C from "../../config/constants.js";
import { mergeTierImageUrl } from "../../assets/merge-tier-urls.js";
import { getCachedImage } from "../../assets/image-cache.js";

function getAssetId(tier) {
  var info = C.EVOLUTION_CHAIN && C.EVOLUTION_CHAIN[tier];
  return info && info.assetId ? info.assetId : null;
}

function getTierImage(tier) {
  var assetId = getAssetId(tier);
  if (!assetId) return null;
  return getCachedImage(mergeTierImageUrl(assetId));
}

export class RunMergePickup {
  constructor(progress, bottomCenterPosition, tier, width) {
    this.progress = progress;
    this.bottomCenterPosition = bottomCenterPosition;
    this.tier = tier;
    this.width = width;
    this.caught = false;
    this.missed = false;
    this.catchChecked = false;
  }
  getType() { return "merge_pickup"; }
  getAspectRatio() {
    var img = getTierImage(this.tier);
    if (img && img.naturalWidth > 0 && img.naturalHeight > 0) {
      return img.naturalWidth / img.naturalHeight;
    }
    return 1;
  }
  getDrawImage() {
    return getTierImage(this.tier);
  }
  draw(ctx, pixelX, pixelY, pixelW, pixelH) {
    if (this.caught) return;
    ctx.save();
    var fallbackColor = (C.MERGE_PICKUP_COLORS && C.MERGE_PICKUP_COLORS[this.tier]) || "#94a3b8";
    var img = getTierImage(this.tier);
    if (img) {
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = "high";
      ctx.drawImage(img, pixelX, pixelY, pixelW, pixelH);
    } else {
      ctx.fillStyle = fallbackColor;
      ctx.fillRect(pixelX, pixelY, pixelW, pixelH);
      ctx.fillStyle = "#1e293b";
      ctx.font = "10px monospace";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      var info = C.EVOLUTION_CHAIN && C.EVOLUTION_CHAIN[this.tier];
      ctx.fillText(info ? info.label : "?", pixelX + pixelW / 2, pixelY + pixelH / 2);
    }
    ctx.restore();
  }
}